import { Validations } from '../../types'

export function validationsFixture({ errorCode = null } = {}): Validations {
  return {
    errorCode
  }
}
